<template>
  <v-col v-if="currentPageName === 'home'">
    <v-row
      class="justify-center align-self-start"
    >
      <v-col
        class="col-sm-12 col-md-9 col-lg-9 col-12 mt-0"
      >
        <v-row>
          <v-col class="col-4">
            <bookmark-list />
            <!--            <reports-list class="mt-4" />-->
          </v-col>

          <v-col class="col-4">
            <network-list />
            <home-bar />
          </v-col>

          <v-col class="col-4">
            <contact-card />
            <contact-list
              v-if="false"
              class="mt-4"
            />
          </v-col>
        </v-row>
      </v-col>

      <v-col
        class="col-sm-12 col-md-3 col-lg-3 col-12 mt-0"
      >
        <release-card />
        <release-brief />
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapGetters: mapAuthGetters } = createNamespacedHelpers('auth')
const { mapGetters: mapToolsGetters } = createNamespacedHelpers('tools')

export default {
  name: 'Home',
  components: {
    BookmarkList: () => import('src/bookmark/views/BookmarkList'),
    ContactCard: () => import('src/dashboard/components/ContactCard'),
    ContactList: () => import('src/dashboard/components/ContactList'),
    HomeBar: () => import('src/home/components/HomeBar'),
    NetworkList: () => import('src/network/views/NetworkList'),
    ReleaseBrief: () => import('src/dashboard/components/ReleaseBrief'),
    ReleaseCard: () => import('src/dashboard/components/ReleaseCard'),
    // ReportsList: () => import('src/dashboard/components/ReportsList'),
  },
  computed: {
    ...mapAuthGetters([
      'isActiveUser',
      'isInternalUser',
    ]),
    ...mapToolsGetters([
      'currentPageName',
    ]),
  },
}
</script>
